module.exports = __webpack_public_path__ + "img/menu-video-active.b73d0def.svg";